<template>
    <div class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">上传电子合同
                </el-button>
            </div>
            <div id="print">
                <div id="printArea"
                     class="printableArea"
                     :class="{'ph':!printOn,'show':printOn}"
                     style=";position: relative;">
                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div >
                                <h3 class="title">教学设备租赁归还确认书</h3>

                            </div>
                            <div >
                                <p><b>出借人：上海墨帝教育科技服务有限公司</b></p>
                            </div>
                            <div >
                                <p><b>租赁人：<span style="text-decoration: underline">方新生</span></b></p>
                                <p><b>租赁人监护人：<span style="text-decoration: underline">方父亲</span></b></p>
                                <p><b>租赁人/租赁人监护人身份证号：<span style="text-decoration: underline">232323455683756473</span></b></p>
                                <p><b>联系方式：<span style="text-decoration: underline">232323455683756473</span></b></p>
                            </div>
                            <br>
                            <div >
                                <p>租赁产品：</p>
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>产品名称</th>
                                            <th>序列号</th>
                                            <th>备注</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="item in products">
                                            <td>{{item.name}}</td>
                                            <td>{{item.serialNumber}}</td>
                                            <td>{{item.remark}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p>
                                    归还日期：<span style="text-decoration: underline"> 2020 </span>年<span style="text-decoration: underline"> 2 </span>月<span style="text-decoration: underline"> 10 </span>日
                                </p>
                            </div>
                            <br>
                            <div >
                                <p>押金<br>
                                    □退回账户：<br>
                                    开户行：<span style="text-decoration: underline"> 232 </span><br>
                                    银行账号：<span style="text-decoration: underline"> 232 </span><br>
                                    开户人：<span style="text-decoration: underline"> 232 </span><br>
                                    □支付《墨帝教育服务服务协议书》相关费用<br>
                                </p>
                            </div>
                            <br>
                            <div >
                                <p>本回执单仅用于确认租赁人与本公司签订的《教学设备租赁合同》中所述的设备已归还，其他事项以《教学设备租赁合同》及《墨帝教育服务服务协议书》中约定为准。<br></p>
                            </div>
                            <br>
                            <div style="float: left;width: 50%">
                                <p>上海墨帝教育科技服务有限公司</p>
                                <p>_______年______月______日</p>
                            </div>
                            <div style="float: left;">
                                <p>租赁人/租赁人监护人（签字）：______________</p>
                                <p>_______年______月______日</p>
                            </div>

                            <div style="clear: both"></div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    export default {
        name: 'Dialog_InvoiceDetail',
        data() {
            return {
                QRCodeMsg:'234',
                printOn:true,
                products:[
                    {
                    id:1,
                    name:'iPad2019 32GB WLAN',
                    serialNumber:'',
                    remark:''
                    },
                    {
                        id:1,
                        name:'ApplePencil一代',
                        serialNumber:'',
                        remark:''
                    }],
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            //this.handleInvoiceDetail()
        },
        mounted(){
        },
        methods: {
            handleInvoiceDetail() {
                this.$wApi.send(this.$parentInfo.path, 'anotherInvoiceDetail', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },

        }
    };
</script>
